/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-10-30T07:04:50.785Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '4.0.1-2689334';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
